import * as React from "react"

import Seo from "../components/seo"
import Hero from "../components/Hero"
import ServiceText from "../components/ServiceText"

const tags = [
  {
      id: 1,
      name: 'Organizational Culture'
  },
  {
      id: 2,
      name: 'Future of organizations'
  },
  {
      id: 3,
      name: 'Agile Delivery'
  },
  {
      id: 4,
      name: 'Values'
  },
  {
      id: 5,
      name: 'Goals'
  },
  {
      id: 6,
      name: 'Marketing'
  },
]

let text = 'Organizations are implementing agile, digital first-culture, building your path to the future requires to be resilient and quickly adapt to the high demans of our present.Each organization creates its own culture, thats what makes them unique and allowe them to highlight in their fields, empowering their colaborators and growing together.Thats the reson why we help you to understand your culture and to create the bases to transmit it to the rest of the company, elements that are key for the success in the long term of your customers, your team and your company.  Delivering solutions that enable businesses to be more efficient, innovative and agile.'

const OrganizationalCulture = () => (
  <>
    <Seo title="Organizational Structure" />
    <Hero img={'organizational-culture.png'} title={'Organizational Structure'} />
    <ServiceText text={text}  tags={tags}/>
  </>
)

export default OrganizationalCulture
